import * as React from "react";
import * as classNames from "classnames";
import Loader from "react-loaders";

export interface AttachmentProps {
  fileName: string;
  fileType: string;
  attachmentId?: number;
  src?: string;
  loading?: boolean;
  onDelete?: Function;
}

class Attachment extends React.PureComponent<any, any> {
  render() {
    let src = this.props.attachmentId
      ? `/api/attachments/${this.props.attachmentId}/raw/${this.props.fileName}`
      : this.props.src ? this.props.src : "";

    let thumbElement = undefined;

    if (this.props.fileType.startsWith("image/")) {
      thumbElement = (
        <div
          className={classNames("attachment-container", {
            loading: this.props.loading
          })}
          style={{
            width: "250px",
            height: "150px",
            backgroundImage: `url("${src}") `,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain"
          }}
        >
          <a
            href={src}
            target="_blank"
            style={{ height: "100%", width: "100%", display: "block" }}
          />
        </div>
      );
    } else if (this.props.fileType.toLowerCase() === "video/quicktime") {
      //   thumbElement = (
      //     <div
      //       className={classNames("attachment-container quicktime", {
      //         loading: this.props.loading
      //       })}
      //     />
      //   );
      thumbElement = (
        <div
          className={classNames("attachment-container", "text-center", {
            loading: this.props.loading
          })}
          style={{
            width: "250px",
            height: "150px"
          }}
        >
          <a
            href={src}
            target="_blank"
            style={{ height: "100%", width: "100%", display: "block" }}
          >
            <svg
              style={{ width: "145px", height: "145px" }}
              viewBox="0 0 24 24"
            >
              <path
                fill="#231f20"
                d="M12,3A9,9 0 0,1 21,12C21,13.76 20.5,15.4 19.62,16.79L21,18.17V20A1,1 0 0,1 20,21H18.18L16.79,19.62C15.41,20.5 13.76,21 12,21A9,9 0 0,1 3,12A9,9 0 0,1 12,3M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17C12.65,17 13.26,16.88 13.83,16.65L10.95,13.77C10.17,13 10.17,11.72 10.95,10.94C11.73,10.16 13,10.16 13.78,10.94L16.66,13.82C16.88,13.26 17,12.64 17,12A5,5 0 0,0 12,7Z"
              />
            </svg>
          </a>
        </div>
      );
    } else if (this.props.fileType.startsWith("video/")) {
      thumbElement = (
        <video width="250" height="145" controls preload="metadata">
          <source src={`${src}#t=0.1`} type={this.props.fileType} />
        </video>
      );
    }

    // <i className="fa fa-refresh fa-spin fa-2x fa-fw" />
    return (
      <div
        className="d-inline-block mr-2"
        style={{
          border: "1px solid #818183"
        }}
      >
        <div
          className={classNames("")}
          style={{ position: "relative", display: "table" }}
        >
          {thumbElement}
          {this.props.loading ? (
            <div
              style={{
                position: "absolute",
                top: "45%",
                left: "43%"
              }}
            >
              <Loader type="line-scale-pulse-out-rapid" active />
            </div>
          ) : (
            undefined
          )}
          {this.props.onDelete ? (
            <div
              style={{
                position: "absolute",
                top: "0px",
                right: "0px"
              }}
            >
              <button
                type="button"
                className="btn btn-primary text-danger"
                aria-label="Delete Attachment"
                onClick={() => this.props.onDelete(this.props.attachmentId)}
                style={{ cursor: "pointer" }}
              >
                <i className="fa fa-times-circle fa-2x " />
              </button>
            </div>
          ) : (
            undefined
          )}
          <div
            className="text-center"
            style={{
              backgroundColor: "rgba(46, 44, 45, 1)"
            }}
          >
            <span
              className="d-inline-block"
              style={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                width: "248px"
              }}
            >
              <a href={src} target="_blank" style={{ color: "#fff" }}>
                {this.props.fileName}
              </a>
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default Attachment;